module.exports = __webpack_public_path__ + "img/img2.6f8652f5.png";